import { Field } from '../../util/components/resource/resource-fields';
import { ApiResource } from '../api-resource';
import { Endpoint } from '../api.decorators';
import { Customer } from '../customer/customer.model';
import { Staff } from '../staff/staff.model';
import { UploadStateMap, UploadType } from './lib/upload-request.interfaces';

@Endpoint('upload-requests', 'UploadRequest')
export class UploadRequest<
  T extends UploadType = UploadType,
> extends ApiResource<UploadRequest<T>> {
  @Field()
  customer?: Customer;

  @Field()
  staff?: Staff;

  @Field()
  type!: T;

  @Field()
  state!: UploadStateMap[T];

  @Field()
  uploadHeaders!: Record<string, string>;

  @Field()
  uploadUrl!: string;
}
